// skaliere: Stand einer Instanz mit Werten statt Drahtzahlen, nach den
// generierten Metadaten (Rechnung in werte.ts).

import { TOPICS, TYPEN } from "./schema.gen";
import { skaliereFelder } from "./werte";

/** Stand einer Instanz der Familie `familie` (z. B. "druckwaechter.stand")
 *  mit Werten statt Drahtzahlen. Unbekannte Familie → unverändert. */
export function skaliere<T = Record<string, unknown>>(familie: string, daten: Record<string, unknown>): T {
  const info = TOPICS.find((t) => t.name === familie);
  return info ? skaliereFelder<T>(info.felder, TYPEN, daten) : (daten as T);
}
